import { MENU_CONFIG } from "./menuConfig";
import type { MenuItemConfig } from "../types/auth.types";
import { userHasRouteAccess } from "../utils/roleUtils";

function findMenuItem(
  items: MenuItemConfig[],
  menuId: string
): MenuItemConfig | null {
  for (const item of items) {
    if (item.id === menuId) {
      return item;
    }
    if (item.children) {
      const child = findMenuItem(item.children, menuId);
      if (child) {
        return child;
      }
    }
  }
  return null;
}

/**
 * Returns true when a menu item (by id) is visible for the current user.
 */
export function canAccessMenuItem(menuId: string, userRole: string | null): boolean {
  const menuItem = findMenuItem(MENU_CONFIG, menuId);
  if (!menuItem) {
    return false;
  }

  return userHasRouteAccess(userRole, menuItem.allowedRoles);
}
